module.exports = "/_next/static/images/66c596d0ef5eb6dae9330a7905e1c600-hero-mobile.jpg.webp";